angular.module('app').factory('exportService', [
    'Restangular',
    'settings',
    'FileSaver',
    'Blob',
    function (Restangular, settings, FileSaver, Blob) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/export/");

        return {
            exportProvidersBySkin: function (requestData) {
                 restAngular.one("exportProvidersBySkin").customGET(param(requestData)).then(function (res) {
                     var file = new Blob([res.content], { type: 'text/csv' });
                     FileSaver.saveAs(file, res.file_name);
                });
            },
            exportSkinsByProvider: function (requestData) {
                restAngular.one("exportSkinsByProvider").customGET(param(requestData)).then(function (res) {
                    var file = new Blob([res.content], { type: 'text/csv' });
                    FileSaver.saveAs(file, res.file_name);
                });
            },
            exportSkinsByGame: function (requestData) {
                restAngular.one("exportSkinsByGame").customGET(param(requestData)).then(function (res) {
                    var file = new Blob([res.content], { type: 'text/csv' });
                    FileSaver.saveAs(file, res.file_name);
                });
            },
            exportGames: function (requestData) {
                console.log(requestData)
                restAngular.one("exportGames").customGET(param(requestData)).then(function (res) {
                    var file = new Blob([res.content], { type: 'text/csv' });
                    FileSaver.saveAs(file, res.file_name);
                });
            }
        }
    }
]);
